import { StyleSheet } from 'react-native';
import { neutrals, text } from 'src/theme/colors';

export const style = StyleSheet.create({
  container: {
    gap: 18,
    paddingBottom: 18,
    paddingHorizontal: 16,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    color: neutrals.black,
  },
  iconClose: {
    width: 24,
    height: 24,
    padding: 4,
    color: neutrals.neutralGrays.cement,
  },
  listItem: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 12,
  },
  itemIcon: {
    width: 24,
    height: 24,
  },
  itemText: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: text.secondaryText,
  },
});
